import React      from 'react';
import { Field }  from 'redux-form';
import classNames from 'classnames';

import BaseField from './base/BaseField';
import ErrorIcon from '../../icons/ErrorIcon';

export const RenderCheckboxField = ({ ...props }) => (
  <Field
    component={CheckboxFieldWrapper}
    type={'checkbox'}
    {...props}
  />
);

const CheckboxFieldWrapper = (props) => {
  const {
          input,
          label,
          meta: {
                  touched,
                  error,
                },
        } = props;

  return (
    <div className={classNames('checkbox', { 'checked': input.value === true })}>
      <label>
        <BaseField {...props} />
        <span className={'ic-check'} />
        <span>{label}</span>
      </label>
      {touched && error && (<span className={'error'}><ErrorIcon />{error}</span>)}
    </div>
  );
};